"use client"

import { useResponsive } from "@/core-nextv3/util/useResponsive";
import { HeaderDesk } from "../Views/desktop/compoenents/HeaderDesk";
import { HeaderMobile } from "../Views/mobile/components/Header";

const HeaderLayout = () => 
{
    const { isDesktop } = useResponsive();

    return (
        <>
            {isDesktop ? <HeaderDesk /> : <HeaderMobile />}
        </>
    );
}

export { HeaderLayout };
